import { Clients, ClientWithoutCoClient } from "./types";
import { useMutationFormeBackendApi } from "@modules/forme/queries";
import { BASE_URL } from "./constants";

const useClientIntakeUpdate = () => {
  return useMutationFormeBackendApi<Clients, Clients | ClientWithoutCoClient>({
    method: "POST",
    path: `${BASE_URL}/intake`,
  });
};

export { useClientIntakeUpdate };
